import { collection, getDocs } from 'firebase/firestore';
import { useEffect, useMemo, useState } from 'react';
import {
  CountryMarketConfig,
  CountryMarketConfigs,
  marketConfigs,
} from '../../common/CountryMarketConfig';
import { db } from '../../firebase';

type ExtendedCountryMarketConfig = CountryMarketConfig & { id: string };

export const useCountryMarketConfigs = (): CountryMarketConfigs | undefined => {
  const [countryMarketData, setCountryMarketData] = useState<
    ExtendedCountryMarketConfig[] | undefined
  >();
  const [countryData, setCountryData] = useState<
    ExtendedCountryMarketConfig[] | undefined
  >();

  const marketData = marketConfigs;

  useEffect(() => {
    const getCountryMarketData = async () => {
      const countryMarketDataQuerySnapshot = await getDocs(
        collection(db, 'settings/countryMarkets/configs'),
      );

      const marketData = [] as ExtendedCountryMarketConfig[];

      countryMarketDataQuerySnapshot.forEach((doc) => {
        marketData.push({
          id: doc.id,
          ...doc.data(),
        } as ExtendedCountryMarketConfig);
      });

      setCountryMarketData(marketData);
    };

    const getCountryData = async () => {
      const countryDataQuerySnapshot = await getDocs(
        collection(db, 'settings/countries/configs'),
      );

      const countryData = [] as ExtendedCountryMarketConfig[];

      countryDataQuerySnapshot.forEach((doc) => {
        countryData.push({
          id: doc.id,
          ...doc.data(),
        } as ExtendedCountryMarketConfig);
      });

      setCountryData(countryData);
    };

    getCountryMarketData();
    getCountryData();
  }, []);

  return useMemo(
    () =>
      !!countryMarketData && !!countryData
        ? countryMarketData
            .map((cmc) => ({
              ...cmc,
              ...countryData.find((cc) => cc.id === cmc.countryCluster),
              ...marketData[cmc.marketDisplayName],
              id: cmc.id,
            }))
            .reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {})
        : undefined,
    [countryData, countryMarketData, marketData],
  );
};
